export enum AdditionalSearchType {
    All = 'All',
}

export enum SearchSubSection {
    Command = 'Command',
}

export type AssistantSearchType = `${AdditionalSearchType | SearchType | SearchSubSection}`;

export enum SearchType {
    AvailabilityBlock = 'AvailabilityBlock',
    Bill = 'Bill',
    City = 'City',
    Company = 'Company',
    Customer = 'Customer',
    EnterpriseProfile = 'EnterpriseProfile',
    Locations = 'Locations',
    Navigation = 'Navigation',
    ProductServiceOrder = 'ProductServiceOrder',
    Reservation = 'Reservation',
    ReservationGroup = 'ReservationGroup',
    Resource = 'Resource',
    ResourceBlock = 'ResourceBlock',
    RoutingRule = 'RoutingRule',
    TravelAgency = 'TravelAgency',
    Command = 'Command',
}
